/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Knp_Lookup_Save_Changes_Failed_ToastInputs */

const en_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save some changes: ${i?.message}`)
};

const fr_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'enregistrement de certaines modifications : ${i?.message}`)
};

const de_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einige Änderungen konnten nicht gespeichert werden: ${i?.message}`)
};

const it_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile salvare alcune modifiche: ${i?.message}`)
};

const ru_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось сохранить некоторые изменения: ${i?.message}`)
};

const es_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron guardar algunos cambios: ${i?.message}`)
};

const zh_cn2_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`部分更改保存失败：${i?.message}`)
};

const ja_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`一部の変更を保存できませんでした: ${i?.message}`)
};

const hi_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कुछ परिवर्तन सहेजने में विफल: ${i?.message}`)
};

const pt_pt2_knp_lookup_save_changes_failed_toast = /** @type {(inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao salvar algumas alterações: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to save some changes: {message}" |
*
* @param {Knp_Lookup_Save_Changes_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_save_changes_failed_toast = /** @type {((inputs: Knp_Lookup_Save_Changes_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Save_Changes_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "de") return de_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "it") return it_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "es") return es_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_save_changes_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_save_changes_failed_toast(inputs)
	return en_knp_lookup_save_changes_failed_toast(inputs)
});